module.exports = __webpack_public_path__ + "img/C9C7BE_55514B_888279_7B6E5F-256px.4e9cad56.png";